import { Map } from 'immutable';

import BaseStore from './BaseStore';
import { ActionTypes } from '../constants/AppConstants';


class DaySaveStore extends BaseStore {

    getInitialState () {
        return new Map({
            results: new Map()
        });
    }

    getKey(search) {
        return JSON.stringify(search.serialize());
    }

    setResult (search, result) {
        this.setState(this.state.setIn(['results', this.getKey(search)], result));
    }

    getResults (search) {
        return this.state.getIn(['results', this.getKey(search)], null);
    }

    handleSearchStarted ({ search }) {
        const searchResults = new Map({ pending: true });
        this.setResult(search, searchResults);
    }

    handleSearchFinished ({ search, searchResults }) {
        this.setResult(search, searchResults);
    }

    getActionHandlers () {
        return {
            [ActionTypes.DAYSAVE_SEARCH_STARTED]: this.handleSearchStarted,
            [ActionTypes.DAYSAVE_SEARCH_FINISHED]: this.handleSearchFinished
        };
    }
}

const storeInstance = new DaySaveStore();

export default storeInstance;
